import request from '@/utils/request'
import URL from './urlTranslator'

// 获取收费项目列表
export function getPayServiceList(params) {
  return request({
    url: URL.mdm.payService.payServiceInfo,
    method: 'get',
    params
  })
}

// 新增收费项目
export function addPayService(data) {
  return request({
    url: URL.mdm.payService.payServiceInfo,
    method: 'post',
    data
  })
}

// 编辑收费项目
export function updatePayService(data) {
  return request({
    url: URL.mdm.payService.payServiceInfo,
    method: 'put',
    data
  })
}

// 删除收费项目
export function batchDelPayService(data) {
  return request({
    url: URL.mdm.payService.payServiceInfo,
    method: 'delete',
    data
  })
}

// 设置服务项目类型
export function settingServiceType(serviceType, data) {
  return request({
    url: `${URL.mdm.payService.settingServiceType}/${serviceType}`,
    method: 'put',
    data
  })
}

// 批量设置默认
export function settingDefault(data) {
  return request({
    url: URL.mdm.payService.settingDefault,
    method: 'put',
    data
  })
}

// 批量取消默认
export function cancelSettingDefault(data) {
  return request({
    url: URL.mdm.payService.cancelSettingDefault,
    method: 'put',
    data
  })
}

// 合并收费项目
export function combineChargeItem(params) {
  return request({
    url: URL.mdm.payService.combineChargeItem,
    method: 'get',
    params
  })
}

// 启用/禁用项目
export function enableOrNot(data) {
  return request({
    url: URL.mdm.payService.enableOrNot,
    method: 'post',
    data
  })
}

// 查询没有关联费用组的收费项目
export function queryChargeItemNoUse() {
  return request({
    url: URL.mdm.payService.queryChargeItemNoUse,
    method: 'get'
  })
}

// 根据费用项ID列表批量查询费用项信息
// data: { itemIdList: number[] }
export function getChargeItemsByItemIds(data) {
  return request({
    url: URL.mdm.payService.getChargeItemsByItemIds,
    method: 'post',
    data
  })
}
